import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoBitrateMaxInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import { VideoBitrateEnum } from '../../../types/enums/VideoBitrateEnum';
import Help from '../../Help/Help';

export const VideoBitrateMaxInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ bitrateMax, setBitrateMax ] = useState<number>(project.encoder.transcoderVideoBitrateMax);
  const debounce = 100;
  const min = VideoBitrateEnum.Low;
  const max = VideoBitrateEnum.VeryHigh + 2000;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = bitrateMax;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setBitrateMax(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoBitrateMax: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoBitrateMax: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setBitrateMax(project.encoder.transcoderVideoBitrateMax);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.transcoderVideoBitrateMax])

  return (
    <div className="video-bitrate-max-input">
      <div className="input-title">
        {t('producer.inputs.video-bitrate-max.title')}
        <Help
          title="Maximum Bitrate"
          text="Maximum Bitrate sets the upper limit for your video stream's data rate.<br/><br/>- This prevents the stream from exceeding a certain bandwidth, which can help avoid network congestion.<br/>- Setting it too low may reduce video quality during complex or fast-moving scenes.<br/>- Setting it higher allows better quality but requires more network capacity.<br/><br/>Use this setting to balance video quality with available bandwidth."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.video-bitrate-max.placeholder"
        value={bitrateMax.toString()}
        onChange={(value) => {setBitrateMax(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.video-bitrate-max.footer')}</div>
    </div>
  );
};

export default React.memo(VideoBitrateMaxInput);
